import {ChangeDetectionStrategy, Component, computed, inject} from '@angular/core';
import {CareproviderUnitService} from '../../../../../../services/careprovider-unit.service';
import {ReferralInfo} from '../../../../../../types/ReferralInfo';
import {WpService} from '../../../../../../services/wp.service';

@Component({
  selector: 'app-cpru-referral',
  templateUrl: './cpru-referral.component.html',
  styleUrl: './cpru-referral.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'block rounded-lg bg-white px-4 py-5 border-l-4 border-duck-blue-5 border-y border-r',
  },
})
export class CpruReferralComponent {
  private wpService = inject(WpService);
  private careproviderUnitService = inject(CareproviderUnitService);
  protected careproviderUnit = this.careproviderUnitService.careproviderUnit;
  protected referralInfo = computed<ReferralInfo>(() => this.careproviderUnit()?.referral_info);
  public updateDateFull = computed<string>(() =>
    this.wpService.getFormattedDate(this.referralInfo()?.author?.lastUpdated, 'full'),
  );
}
